import React, { useEffect } from 'react';
import { CHECKOUT_PICK_UP_PAYMENT } from '../../other/CheckoutConstants';
import { translate } from '../../../../Services/translation';
import CheckoutDeliveryPickupSelect from './components/CheckoutDeliveryPickupSelect';

const CheckoutDeliveryPickup = ({ checkout, setSelectedReseller }) => {
  const { payload } = checkout || {};
  const {
    isBusinessCustomer,
    selectedPaymentMethod,
    selectedResellerId,
    storeView,
  } = payload || {};
  const { defaultStore, stores } = storeView || {};

  const indexedStores = stores
    ?.filter((store) => store.isPickup)
    ?.map((store, index) => ({
      ...store,
      index: index,
    }));

  const selectedStore = stores?.find(
    (store) => store.organization === selectedResellerId
  );

  useEffect(() => {
    if (
      selectedPaymentMethod.id != CHECKOUT_PICK_UP_PAYMENT &&
      selectedResellerId != null
    ) {
      setSelectedReseller(null);
    }
  }, [selectedPaymentMethod?.id, selectedResellerId, setSelectedReseller]);

  if (
    isBusinessCustomer ||
    !indexedStores?.length ||
    selectedPaymentMethod.id !== CHECKOUT_PICK_UP_PAYMENT
  ) {
    return null;
  }

  return (
    <div className="checkout-section">
      <h2 className="heading-2 mb-8">
        {translate('checkout.storepicker.title')}
      </h2>
      <CheckoutDeliveryPickupSelect
        stores={indexedStores}
        defaultStore={defaultStore}
        setSelectedReseller={setSelectedReseller}
      />
      <h3 className="heading-2 border-border-primary mb-4 mt-8 border-t pt-8">
        {translate('checkout.storepicker.selected_store')}
      </h3>
      {selectedStore ? (
        <div>
          <p className="body body_bold leading-base mb-2 last:mb-0">
            {selectedStore.name || '-'}
          </p>
          {selectedStore.company && (
            <p className="body-sm">{selectedStore.company}</p>
          )}
          {selectedStore.address && (
            <p className="body-sm">{selectedStore.address}</p>
          )}
          {!!selectedStore?.url && (
            <p className="body-sm leading-base mt-2">
              <a
                className="link"
                href={selectedStore.url}
                target="_blank"
                rel="noreferrer"
              >
                {translate('checkout.storepicker.read_more')}
              </a>
            </p>
          )}
        </div>
      ) : (
        <p className="body">
          {translate('checkout.storepicker.no_store_selected')}
        </p>
      )}
    </div>
  );
};

export default CheckoutDeliveryPickup;
